// extracted by mini-css-extract-plugin
export default {"wrapper":"Icon_wrapper__pLqa0","small":"Icon_small__pw4yD","medium":"Icon_medium__+EJdQ","large":"Icon_large__sZCK8"};